import { ThemeProvider } from "@emotion/react";
import Box from "@mui/material/Box";
import { createTheme } from "@mui/material/styles";
import * as React from "react";
import { Keyboard, Mousewheel, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import Creator from "./Creator";
import Discover from "./Discover";
import Earn from "./Earn";
import Welcome from "./Welcome";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const All = () => {
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box>
          <Swiper
            cssMode={true}
            navigation={true}
            pagination={true}
            mousewheel={true}
            keyboard={true}
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="mySwiper"
            style={{display: "flex",paddingBottom:"20px",color:"#ffffff"}}
            // sx={{"& .swiper-pagination-bullet-active": {
            //   backgroundColor:"#ffffff",
            // }}}
          >
            <SwiperSlide><Welcome /></SwiperSlide>
            <SwiperSlide><Discover /></SwiperSlide>
            <SwiperSlide><Creator /></SwiperSlide>
            <SwiperSlide><Earn /></SwiperSlide>
            </Swiper>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default All;
